import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const dataCheckGuard = createFeatureGuard(Feature.DataCheck);